import { render, staticRenderFns } from "./BS_AgreementSetting.vue?vue&type=template&id=073e5a18&scoped=true&"
import script from "./BS_AgreementSetting.vue?vue&type=script&lang=js&"
export * from "./BS_AgreementSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e5a18",
  null
  
)

export default component.exports